import { CheckoutState } from '../../state';
import { isNosDemoEnabled, isNosIntegrationEnabled } from '../splitio';
import { getNamespaceValue } from '../utils/selector';

export const getIsNosSourceOfTruth = (state: CheckoutState) =>
    isNosDemoEnabled(state) ||
    (isNosIntegrationEnabled(state) &&
        getNamespaceValue(state.order, 'isNosSourceOfTruth', false));
